module.exports = __webpack_public_path__ + "static/media/HeroImage2xQ60.a1de4048.webp";